import { Typography } from "@mui/material";
import { BaseStyledButton } from "./shared/ButtonStyles";

interface TextButtonProps {
  label: string;
  onClick?: () => void;
  selected?: boolean;
  subText?: string;
  disabled?: boolean;
}

export function TextButton({ label, onClick, selected, subText, disabled = false }: TextButtonProps) {
  return (
    <BaseStyledButton onClick={onClick} variant={selected ? "contained" : "outlined"} disabled={disabled}>
      <Typography className="button-label" variant="body1">
        {label}
      </Typography>
      {subText && (
        <Typography className="button-subtext" variant="body2">
          {subText}
        </Typography>
      )}
    </BaseStyledButton>
  );
}
